import { useEffect, useRef, useState } from 'react'

import useAppDispatch from 'hooks/useAppDispatch'
import useGoogleTagManager from 'hooks/useGoogleTagManager'
import useUser from 'hooks/useUser'
import { logoutUser } from 'state/user/actions'

export default function useLoggedInUserDropdown() {
    const googleTagManager = useGoogleTagManager()
    const dispatch = useAppDispatch()
    const { user } = useUser()
    const [toggleDropdown, setToggleDropdown] = useState(false)
    const node = useRef<HTMLLIElement>(null)

    const handleLogout = () => {
        googleTagManager.trackNavbarEvent('Log Out', '#/')
        dispatch(logoutUser())
    }

    const clickOutside = (e: MouseEvent) => {
        if (node?.current?.contains(e.target as Node)) {
            return
        }

        setToggleDropdown(false)
    }

    useEffect(() => {
        document.addEventListener('click', clickOutside)

        return () => {
            document.removeEventListener('click', clickOutside)
        }
    }, [])

    return { user, node, toggleDropdown, setToggleDropdown, handleLogout }
}
